import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  // Só entram aqui destinos que existem de verdade em App.jsx — o rodapé
  // anterior linkava para páginas (blog, termos, FAQ, etc.) que nunca foram
  // criadas, e todo visitante caía em 404 ao clicar em qualquer item.
  const footerSections = [
    {
      title: 'Produto',
      links: [
        { label: 'Comandos', path: '/comandos' },
        { label: 'Planos', path: '/#planos' },
      ],
    },
    {
      title: 'Conta',
      links: [
        { label: 'Entrar', path: '/login' },
        { label: 'Criar conta', path: '/signup' },
      ],
    },
  ];

  return (
    <footer className="bg-rn-navy text-white pt-16 pb-8">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          {/* Logo and Description */}
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center mb-6">
              <img
                src="/assets/images/rnplugin-horizontal-ondark.png"
                alt="RNPlugin"
                width="128"
                height="32"
                className="h-8 w-auto"
              />
            </Link>
            <p className="text-rn-text-soft-dk mb-6 max-w-sm">
              Automação para rodovia, ferrovia, loteamento e topografia no Civil 3D.
            </p>
          </div>

          {/* Footer Sections */}
          {footerSections.map((section) => (
            <div key={section.title}>
              <h3 className="font-semibold mb-4">{section.title}</h3>
              <ul className="space-y-2">
                {section.links.map((link) => (
                  <li key={link.path}>
                    {link.path.includes('#') ? (
                      <a
                        href={link.path}
                        className="text-rn-text-soft-dk hover:text-rn-orange transition-colors"
                      >
                        {link.label}
                      </a>
                    ) : (
                      <Link
                        to={link.path}
                        className="text-rn-text-soft-dk hover:text-rn-orange transition-colors"
                      >
                        {link.label}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-rn-navy-line pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-rn-text-soft-dk text-sm mb-4 md:mb-0">
              © {currentYear} RNPlugin. Todos os direitos reservados.
            </p>
            <div className="flex items-center space-x-4">
              <img
                src="/assets/images/rnplugin-horizontal-ondark.png"
                alt="RNPlugin"
                width="96"
                height="24"
                className="h-6 w-auto"
              />
              <span className="text-rn-text-soft-dk text-sm">Feito com ♥</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
